<template>
    <div>
        <div
                class="google-map"
                ref="googleMap"
        />
    </div>
</template>
<script>
    import '../../scss/theme/components/Map.scss';
    import {markerInfoTemplate} from './markerInfoTemplate';
    import {POIInfoTemplate} from './POIInfoTemplate';
    import googleMapsLoader from './googleMapsLoader';
    import * as caret from '../../static/caret-round.svg';
    import * as POIClosedSvg from '../../static/POI-window-closed.svg';

    export default {
        props: {
            apiKey: String,
            markers: {
                type: Array,
                validator: (prop) => prop.every(e => typeof e === 'object')
            },
            // pOISearch: {
            //
            //     POIType: {
            //         type: String,
            //         default: 'none',
            //     },
            //     radius: {
            //         type: String,
            //         default: '10000',
            //     },
            // },
            zoom: {
                type: Number,
                default: 10
            },
            fitBounds: {
                type: Boolean,
                default: true,
            }
        },
        render(h) {
            this.renderer = h;
            return h({
                template: this.template,
            });
        },
        data() {
            return {
                map: null,
                renderer: null,
                mapConfig: {},
                overlay: null,
                infoWindow: null,
            };
        },
        async mounted() {
            googleMapsLoader.apiKey = this.apiKey;
            await googleMapsLoader.loadGMapsApi();
            this.initializeMap();
        },

        methods: {
            initializeMap() {
                const mapContainer = this.$refs.googleMap;
                const mapOptions = {
                    streetViewControl: false,
                    mapTypeControl: false,
                    zoom: this.zoom,
                    zoomControl: true,
                    styles: [
                        {
                            'featureType': 'poi',
                            'stylers': [
                                {
                                    'visibility': 'off',
                                },
                            ],
                        },
                    ],
                };

                if (this.markers.length) {
                    mapOptions.center = {
                        lat: this.markers[0].position.lat,
                        lng: this.markers[0].position.lng,
                    };
                }

                this.map = new googleMapsLoader.googleMapsApi.maps.Map(
                    mapContainer, mapOptions,
                );

                let marker;

                for (let i = 0; i < this.markers.length; i++) {
                    marker = googleMapsLoader.createHTMLMapMarker({
                        latlng: this.markers[i].position,
                        map: this.map,
                        // eslint-disable-next-line max-len
                        html: `<div class="marker-wrapper"><div class="custom-marker"><div class="marker-title">${'$' + this.formatPrice(this.markers[i].params.price)}</div></div><img src="${caret}" alt="caret" class="marker-caret"></div>`
                    });

                    let vm = this;
                    googleMapsLoader.googleMapsApi.maps.event.addListener(marker, 'click', (function (marker, i, vm) {
                        return function () {
                            if (vm.infoWindow) {
                                vm.infoWindow.close();
                            }
                            vm.infoWindow = new googleMapsLoader.googleMapsApi.maps.InfoWindow({
                                content: markerInfoTemplate(vm.markers[i].params),
                            });
                            vm.infoWindow.open(this.map, marker);
                        };
                    })(marker, i, vm));
                }

                if (this.fitBounds) {
                    let markerBounds = new googleMapsLoader.googleMapsApi.maps.LatLngBounds();
                    this.markers.forEach(function (marker) {
                        marker = new googleMapsLoader.googleMapsApi.maps.LatLng(
                            marker.position.lat,
                            marker.position.lng
                        );

                        markerBounds.extend(marker);
                    });

                    this.map.fitBounds(markerBounds);
                }

                let placesService = new googleMapsLoader.googleMapsApi.maps.places.PlacesService(this.map);

                let request = {
                    location: {
                        lat: this.map.getCenter().lat(),
                        lng: this.map.getCenter().lng(),
                    },
                    radius: this.POISearch.radius,
                };

                if (this.POISearch.POIType !== 'none') {
                    request.type = this.POISearch.POIType;
                }

                placesService.nearbySearch(request, this.callback);

                this.map.addListener('click', (event) => {
                    if (event.placeId) {
                        event.stop();
                        placesService.getDetails({placeId: event.placeId}, (place, status) => {
                            let params = {
                                'name': place.name,
                                'formattedAddress': place.formatted_address,
                            };
                            if (place.photos) {
                                params.photoSrc = place.photos[0].getUrl({maxHeight: 500});
                            }

                            if (this.infoWindow) {
                                this.infoWindow.close();
                            }
                            this.infoWindow = new googleMapsLoader.googleMapsApi.maps.InfoWindow({
                                maxWidth: 300,
                                content: POIInfoTemplate(params),
                                position: event.latLng,
                            });

                            this.infoWindow.open(this.map);
                        });
                    }
                    // TODO add clusters
                });
            },

            callback(results, status, pagination) {
                if (status === googleMapsLoader.googleMapsApi.maps.places.PlacesServiceStatus.OK) {
                    for (let i = 0; i < results.length; i++) {
                        this.createMarker(results[i]);
                    }
                    if (pagination.hasNextPage) {
                        pagination.nextPage();
                    }
                }
            },
            formatPrice(num) {
                return Math.abs(num) > 999 ?
                    Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'K' :
                    Math.sign(num) * Math.abs(num);
            },
            createMarker(place) {
                if (place.types.includes(this.POISearch.POIType) || this.POISearch.POIType === 'none') {
                    place.icon = {
                        url: POIClosedSvg,
                        origin: new googleMapsLoader.googleMapsApi.maps.Point(0, 0),
                        anchor: new googleMapsLoader.googleMapsApi.maps.Point(7, 16),
                        scaledSize: new googleMapsLoader.googleMapsApi.maps.Size(14, 14),
                    };
                    let placeLoc = place.geometry.location;
                    let marker = new googleMapsLoader.googleMapsApi.maps.Marker({
                        map: this.map,
                        position: placeLoc,
                        icon: {
                            url: POIClosedSvg,
                            origin: new googleMapsLoader.googleMapsApi.maps.Point(0, 0),
                            anchor: new googleMapsLoader.googleMapsApi.maps.Point(7, 16),
                            scaledSize: new googleMapsLoader.googleMapsApi.maps.Size(16, 16),
                        },
                    });

                    let placesService = new googleMapsLoader.googleMapsApi.maps.places.PlacesService(this.map);

                    googleMapsLoader.googleMapsApi.maps.event.addListener(marker, 'click', () => {
                        placesService.getDetails({placeId: place.place_id}, (place) => {
                            let params = {
                                'name': place.name,
                                'formattedAddress': place.formatted_address,
                            };
                            if (place.photos) {
                                params.photoSrc = place.photos[0].getUrl({maxHeight: 500});
                            }
                            if (this.infoWindow) {
                                this.infoWindow.close();
                            }
                            this.infoWindow = new googleMapsLoader.googleMapsApi.maps.InfoWindow({
                                maxWidth: 300,
                                content: POIInfoTemplate(params),
                                position: placeLoc,
                            });

                            this.infoWindow.open(this.map);
                        });
                    });
                }
            },
        },
    };
</script>
<style lang="scss">
</style>
